(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Calculate 50% of total page height
      const pageHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );
      const thirtyPercentScroll = pageHeight * 0.5; // 50% of page height

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > thirtyPercentScroll) {
        // Scrolling down and past 50% of page
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        
        // Clear any existing timeout
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
        }
        
        // Add delay before hiding
        this.hideTimeout = setTimeout(() => {
          requestAnimationFrame(this.hide.bind(this));
        }, 3000); // 3 second delay
        
      } else if (scrollTop < this.currentScrollTop && scrollTop > thirtyPercentScroll) {
        // Scrolling up but still past 50% of page
        this.header.classList.add('scrolled-past-header');
        
        // Clear hide timeout when scrolling up
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
          this.hideTimeout = null;
        }
        
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= thirtyPercentScroll) {
        // At top 50% of page - show announcement bar
        this.header.classList.remove('scrolled-past-header');
        
        // Clear hide timeout when at top
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
          this.hideTimeout = null;
        }
        
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  //mobile search toggle functionality
document.addEventListener('DOMContentLoaded', function() {
    const mobileSearchToggle = document.querySelector('.mobile-search-toggle');
    const mobileSearchContainer = document.querySelector('.mobile-search-container');
    
    if (mobileSearchToggle && mobileSearchContainer) {
      mobileSearchToggle.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        if (mobileSearchContainer.classList.contains('active')) {
          mobileSearchContainer.classList.remove('active');
          mobileSearchContainer.style.display = 'none';
        } else {
          mobileSearchContainer.classList.add('active');
          mobileSearchContainer.style.display = 'block';
          setTimeout(() => {
            const searchInput = mobileSearchContainer.querySelector('input[type="search"]');
            if (searchInput) searchInput.focus();
          }, 100);
        }
      });
      
      // Close search when clicking outside
      document.addEventListener('click', function(event) {
        if (!mobileSearchContainer.contains(event.target) && 
            !mobileSearchToggle.contains(event.target) && 
            mobileSearchContainer.classList.contains('active')) {
          mobileSearchContainer.classList.remove('active');
          mobileSearchContainer.style.display = 'none';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
